import { Chip, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import { makeModeAwareAccent, makeModeAwareAccentBackground } from "@entrilia/shared/utilities/colorHelper";

const LiveStatus = () => {
  return (
    <Chip
      label={
        <Typography variant="caption" sx={{ fontWeight: 500 }}>
          Template:
          <Typography
            variant="caption"
            sx={(t) => ({ ml: 0.5, fontWeight: "inherit", color: makeModeAwareAccent(t, green) })}
          >
            Live
          </Typography>
        </Typography>
      }
      sx={(t) => ({ bgcolor: makeModeAwareAccentBackground(t, green) })}
    />
  );
};

export default LiveStatus;
